import { TeaResources } from "../resources";
import { isVGeo, generateScriptTag } from "./shared";
const _getTeaPreScriptString = (globalName = "collectEvent") => `(function(win, export_obj) { win['LogAnalyticsObject'] = export_obj; if (!win[export_obj]) { function _collect() { _collect.q.push(arguments); } _collect.q = _collect.q || []; win[export_obj] = _collect; } win[export_obj].l = +new Date(); })(window, '${globalName}');`;
const getTeaPreScriptInlineStringTag = (globalName = "collectEvent") => generateScriptTag({
  script: _getTeaPreScriptString(globalName)
});
const _getTeaCspPreScriptScriptTagStringByVRegion = (vregion) => generateScriptTag({
  src: TeaResources.cspPreScriptUrlVRegionMap[vregion]
});
const _getTeaCspPreScriptScriptTagStringByVGeo = (vgeo) => generateScriptTag({
  src: TeaResources.cspPreScriptUrlVGeoMap[vgeo]
});
const _getTeaGeckoCspPreScriptScriptTagStringByVRegion = (vregion) => generateScriptTag({
  src: TeaResources.geckoCspPreScriptUrlVRegionMap[vregion]
});
const _getTeaGeckoCspPreScriptScriptTagStringByVGeo = (vgeo) => generateScriptTag({
  src: TeaResources.geckoCspPreScriptUrlVGeoMap[vgeo]
});
const getTeaCspPreScriptScriptTag = (region, useGeckoResource = false) => {
  if (isVGeo(region)) {
    return useGeckoResource ? _getTeaGeckoCspPreScriptScriptTagStringByVGeo(region) : _getTeaCspPreScriptScriptTagStringByVGeo(region);
  } else {
    return useGeckoResource ? _getTeaGeckoCspPreScriptScriptTagStringByVRegion(region) : _getTeaCspPreScriptScriptTagStringByVRegion(region);
  }
};
const _getTeaSdkScriptTagStringByVRegion = (vregion) => generateScriptTag({
  async: true,
  src: TeaResources.sdkUrlVRegionMap[vregion]
});
const _getTeaSdkScriptTagStringByVGeo = (vgeo) => generateScriptTag({
  async: true,
  src: TeaResources.sdkUrlVGeoMap[vgeo]
});
const _getTeaGeckoSdkScriptTagStringByVRegion = (vregion) => generateScriptTag({
  async: true,
  src: TeaResources.geckoSdkUrlVRegionMap[vregion]
});
const _getTeaGeckoSdkScriptTagStringByVGeo = (vgeo) => generateScriptTag({
  async: true,
  src: TeaResources.geckoSdkUrlVGeoMap[vgeo]
});
const getTeaSdkScriptTag = (region, useGeckoResource = false) => {
  if (isVGeo(region)) {
    return useGeckoResource ? _getTeaGeckoSdkScriptTagStringByVGeo(region) : _getTeaSdkScriptTagStringByVGeo(region);
  } else {
    return useGeckoResource ? _getTeaGeckoSdkScriptTagStringByVRegion(region) : _getTeaSdkScriptTagStringByVRegion(region);
  }
};
const _getTeaInitRegionsConfigByVRegion = (vregion) => ({
  channel_domain: TeaResources.channelDomainVRegionMap[vregion]
});
const _getTeaInitRegionsConfigByVGeo = (vgeo) => ({
  channel_domain: TeaResources.channelDomainVGeoMap[vgeo]
});
const getTeaInitRegionsConfig = (region) => isVGeo(region) ? _getTeaInitRegionsConfigByVGeo(region) : _getTeaInitRegionsConfigByVRegion(region);
const TeaUtils = {
  getPreScriptInlineStringTag: getTeaPreScriptInlineStringTag,
  getCspPreScriptScriptTag: getTeaCspPreScriptScriptTag,
  getSdkScriptTag: getTeaSdkScriptTag,
  getInitRegionsConfig: getTeaInitRegionsConfig
};
export {
  TeaUtils,
  getTeaCspPreScriptScriptTag,
  getTeaInitRegionsConfig,
  getTeaPreScriptInlineStringTag,
  getTeaSdkScriptTag
};

//# sourceMappingURL=tea.js.map